// @ts-nocheck
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import useGetGlLedgersList from '@hooks/Finance/useGetGlLedgersList';

export const SelectGL = ({ value, onChange }) => {
  const { t, i18n } = useTranslation();
  const { OptionsLedgers, loading } = useGetGlLedgersList();

  
  return (
    <Select
      classNamePrefix='react-select'
      isLoading={loading}
      isSearchable={true}
      isClearable
      options={OptionsLedgers}
      value={OptionsLedgers?.find(f => f.value === value)}
      onChange={onChange}
      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
    />
  );
};
